import React, { useState, useEffect, useRef } from 'react';
import { Box, InputLabel, MenuItem, FormControl, Select, Menu, } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import smartfmLogo from '../../src/Assets/smartfm-1.svg'
import nanosoftsologo from '../../src/Assets/ns.png';
import 'typeface-lato';

export default function Home() {
    const [serviceList, setServiceList] = useState([]);
    const [service, setService] = useState('');
    const [productData, setProductData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [ShowProduct, setShowProduct] = useState(false);
    const [branding, setBrandingData] = useState({});
    const [greeting, setGreeting] = useState(getGreeting());
    const [userName, setUserName] = useState([]);
    const [paymentAlertShow,setPaymentAlert]=useState(false);
    const [paymentDesc,setPaymentDes]=useState('');
    const [PayementExpired,setPayementExpired]=useState(false)
    
    function ReadMore({ text, limit = 65 }) {
        const [expanded, setExpanded] = useState(false);

        if (!text) return null;

        return (
            <span>
                {expanded ? text : text.substring(0, limit) + (text.length > limit ? "..." : "")}
                {text.length > limit && (
                    <span
                        onClick={() => setExpanded(!expanded)}
                        style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
                    >
                        {expanded ? "Read Less" : "Read More"}
                    </span>
                )}
            </span>
        );
    }

    const productRef = useRef(null)
    const Service = JSON.parse(process.env.REACT_APP_CLIENTSERVICE) || {};
    
    useEffect(() => {
        getServiceList();
    }, []);

    useEffect(() => {
        if (service) {
            const brandingParams = { "data": { "p77": 1, "p78": 10, "p79": "BrandingID", "p82": 1, "p83": 1 } };
            const url = `${Service[service]}FP95S3`
            getData(url, brandingParams).then((res) => {
                if (res?.Output?.data?.length > 0 && res.Output?.status?.code === "200") {
                    setBrandingData(res?.Output?.data[0])
                }
            })
            paymentAlert();
        }
    }, [service]);

    const handleChange = (event) => {
        setService(event.target.value);
    };

    const getServiceList = () => {
        const url = `${localStorage.getItem('domain')}/api/ServiceList`;
        const params = {
            data: {
                p1: localStorage.getItem('token') || '',
            },
        };

        fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        })
            .then((res) => res.json())
            .then((res) => {
                if (res?.Output?.status?.code === 200 && res?.Output?.data?.length > 0) {
                    setServiceList(res.Output.data);
                    setService(res.Output.data[0]?.OrgName || '');
                }
            })
            .catch((err) => {
                console.error('Service list fetch error:', err);
            });
    };

   const fetchUserProducts = () => {
    const baseUrl = Service[service];

    localStorage.setItem("serviceurl", baseUrl);

    if (!baseUrl) {
        console.error(`No base URL found for service: ${service}`);
        return;
    }

    const url = `${baseUrl}products`;
    const params = {
        p1: localStorage.getItem("token"),
        p2: "",
    };

    setLoading(true);

    fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
    })
        .then(async (response) => {
            const atkn = response.headers.get("atkn");
            localStorage.setItem("x-atkn", atkn || "");
            const data = await response.json();
            return {
                data,
                headers: response.headers,
            };
        })
        .then(({ data }) => {
            if (data?.Output?.status?.code == 200 &&data?.Output?.data?.length > 0) {
                setUserName(data?.Output?.user || "");
                setProductData(data?.Output?.data || []);
            } else {
                setProductData([]);
            }
        })
        .catch((err) => {
            console.error("Product fetch error:", err);
        })
        .finally(() => {
            setLoading(false);
        });
};

    const paymentAlert =()=>{
        const baseUrl = Service[service];
        const url = `${baseUrl}FPC1S3`;
        const params = {"data":{"p4":Number(localStorage.getItem('userid')) || null,"p5":10,"p6":"PAYMENTALERT"}}
        setLoading(true);

        getData(url, params)
            .then((res) => {
                if (res?.Output?.data?.length > 0 && res?.Output?.status.code == 200) {
                    const data = res?.Output?.data
                    setPaymentDes(data[0]?.PaymentAlertDesc || '');
                    setPaymentAlert(true);
                    setPayementExpired(data[0]?.IsExpired)
                }else{
                    fetchUserProducts();
                } 
            })
            .catch((err) => {
                console.error('Product fetch error:', err);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // Profile Menu Handlers
    const handleProfileClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleProductClick = (event) => {
        setShowProduct(!ShowProduct);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (productRef.current && !productRef.current.contains(event.target)) {
                setShowProduct(false);
            }
        }

        if (ShowProduct) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }

    }, [ShowProduct])

    const handleProfileClose = () => {
        setAnchorEl(false);
    };

    const handleSignOut = () => {
        localStorage.clear();
        window.location.href = '/';
    };

    const stayLogin = () => {
        if (PayementExpired) {
            localStorage.clear();
            window.location.href = '/';
        } else {
            setPaymentAlert(false);
            fetchUserProducts()
        }
    }


    const getData = async (url, params) => {
        return fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        }).then((res) => res.json()).then((res) => { return res })

    }

    function getGreeting() {
        const hour = new Date().getHours();

        if (hour >= 5 && hour < 12) {
            return "Good Morning";
        } else if (hour >= 12 && hour < 17) {
            return "Good Afternoon";
        } else if (hour >= 17 && hour < 21) {
            return "Good Evening";
        } else {
            return "Good Night";
        }
    }



    useEffect(() => {

        const interval = setInterval(() => {
            setGreeting(getGreeting());
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="container"
            style={{
                fontFamily: 'Lato',
                letterSpacing: '0.5px'
            }}
        >
            {loading && (
                <div className="loading-overlay">
                    <img
                        src="https://nanotracker.smartfm.cloud/static/media/loading.19f9e9a92f7e3b21f6e8.gif"
                        alt="Loading..."
                        className="loading-image"
                    />
                </div>
            )}

            {
                paymentAlertShow && (
                    <div style={{width:'100%',height:'100vh',position:'absolute',top:'0',left:'0',zIndex:'10',display:'flex',justifyContent:'center',alignItems:'center',backgroundColor: 'rgba(255, 255, 255, 0.5)'}}>
                           <div className='paymentCard'>
                                     <ErrorOutlineRoundedIcon style={{width:'80px',height:'80px',color:'orange'}}/>
                                     <p style={{color:'#807e7e',fontSize:'24px',fontWeight:'600',margin:'10px'}}>Payment Alert</p>
                                     <p style={{margin:'10px'}}>{paymentDesc || 'Payment!!!'}</p>
                                     <div style={{margin:'10px',display:'flex',gap:'15px'}} >
                                        <button className='paymentBtn' style={{backgroundColor:'#e63333'}} onClick={handleSignOut}>CANCEL</button>
                                        <button className='paymentBtn' style={{backgroundColor:'#027e02'}} onClick={stayLogin}>YES</button>
                                     </div>
                           </div>
                    </div>
                )
            }


            <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* <img src={branding.LoginPageClientLogoPath || ''} style={{ width: '120px', height: '60px' }}></img> */}
                <p className='greet'>{greeting || ''}</p>
                <div className="headerRightSide" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                    <Box sx={{ minWidth: 120, display: 'none' }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="service-select-label">Service</InputLabel>
                            <Select
                                labelId="service-select-label"
                                id="service-select"
                                value={service}
                                onChange={handleChange}
                                label="Service"
                            >
                                {serviceList.map((key) => (
                                    <MenuItem key={key.OrgName} value={key.OrgName}>
                                        {key.OrgName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    {/* Profile Icon */}

                    <div className="profile" onClick={handleProfileClick}>
                        <div className="profileCircle">
                            {typeof userName === "string" && userName
                                ? userName.charAt(0).toUpperCase()
                                : "U"}
                        </div>
                        <div className="profileName">
                            <p className="profileUserName">
                                {typeof userName === "string" && userName
                                    ? userName.charAt(0).toUpperCase() + userName.slice(1)
                                    : ""}
                            </p>
                        </div>
                    </div>

                    {/* Profile Menu Popup */}
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleProfileClose}
                    >
                        <MenuItem onClick={handleSignOut}>
                            <LogoutIcon style={{ marginRight: '8px' }} /> Sign Out
                        </MenuItem>
                    </Menu>
                </div>
            </div>

            <div className="cards-section">
                {/* <p className='greet'>{greeting || ''}</p> */}
                <div className="cardcontainer">
                    {
                        productData?.length > 0 ?
                            productData?.length == 1 ?
                                productData.map((obj) => {
                                    return (
                                        <div className='SingleProductContainer'>
                                            <div className='ViewAllProducts' style={{display:'none'}} onClick={handleProductClick}>View Our Products</div>
                                            {ShowProduct && <div className='viewProducts' ref={productRef} style={{display:'none'}}>{
                                                [
                                                    {
                                                        "p1": "IFMSWeb"
                                                    }, {
                                                        "p1": "IFMSWeb"
                                                    }
                                                ].map((el) => {
                                                    return (
                                                        <div className='viewcard'>
                                                            <div className='viewwsubcard'></div>
                                                            <div className='viewcardDetails'>
                                                                <p className='textviewcard' style={{ fontSize: "16px", color: "#232A38", fontWeight: 600 }}>Reach</p>
                                                                <p className='textviewcard' style={{ fontSize: "12px", color: "#696B70" }}>Mobility Solution For Field Technicians</p>
                                                                <p className='textviewcard' style={{ fontSize: "12px", color: "#3378FA", textDecoration: 'underline' }}>Learn more</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}</div>}
                                            <div className='SinglecardTextArea'>
                                                <p className='SingleCardName'>{obj?.productName || ''}</p>
                                                <p className='SingleCardValues'>{obj?.text || ''}</p>
                                                <button className='SingleCardBtn' onClick={() => window.open(obj.domain, "_self")}>Open</button>
                                            </div>
                                            <div> <img src={obj.imgurl ? `${process.env.REACT_APP_NODE_SERVICE}/images/${obj.imgurl}` :''} alt='smartFM' style={{ width: '357px', height: '288px', borderRadius: '7px' }} /></div>
                                        </div>
                                    )
                                })
                                :
                                <div className='multipleCradScontainer'>
                                    <div className='ViewAllProducts' onClick={handleProductClick}>View Our Products</div>
                                    {ShowProduct && <div className='viewProducts' ref={productRef}>{
                                        [
                                            {
                                                "p1": "IFMSWeb"
                                            }, {
                                                "p1": "IFMSWeb"
                                            }
                                        ].map((el) => {
                                            return (
                                                <div className='viewcard'>
                                                    <div className='viewwsubcard'></div>
                                                    <div className='viewcardDetails'>
                                                        <p className='textviewcard' style={{ fontSize: "16px", color: "#232A38", fontWeight: 600 }}>Reach</p>
                                                        <p className='textviewcard' style={{ fontSize: "12px", color: "#696B70" }}>Mobility Solution For Field Technicians</p>
                                                        <p className='textviewcard' style={{ fontSize: "12px", color: "#3378FA", textDecoration: 'underline' }}>Learn more</p>
                                                    </div>
                                                </div>
                                            )
                                        })}</div>}
                                    <div className='clientLogo'>Client Logo</div>
                                    <div className='Multiplecardcantiner'>
                                        {productData?.map((obj) => {
                                            return (<div className="multipleCrard">
                                                <img src={obj?.imgurl || ''} alt='smartFM' className='MultiImage' />
                                                <p className='MultipleCardNname'>{obj?.productName || ''}</p>
                                                <p className="MultipleCardContent">
                                                    <ReadMore text={obj?.text || ""} limit={65} />
                                                </p>
                                                <button className='SingleCardBtn'  onClick={() => window.open(obj.domain, "_self")}>Open</button>
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            :
                            <div>
                                No Products
                            </div>
                    }
                </div>
            </div>

            <div style={{ width: '100%' }}>
                <div className='footer' style={{ padding: '0 5px' }}>
                    <img src={smartfmLogo} alt='BrandingLOGO' className='FooterLogoLeft'/>
                    <img src={nanosoftsologo} alt='BrandingLOGO' className='FooterLogoRight'/>
                </div>
            </div>
        </div>
    );
}
